import { HTTPScheme } from '#common/types';
import { Synchronized } from '#common/util';
import { DataStoreKind, DataStoreRekeyState, } from '#external-files/types';
import { parseWasmResult } from '#wasm/common';
function parseRekeyState(value) {
    if (Object.values(DataStoreRekeyState).includes(value)) {
        return value;
    }
    throw new Error(`Invalid rekey state: ${value}`);
}
export class DataStoresWasm extends Synchronized {
    modAsync;
    constructor(modAsync, mutex) {
        super(mutex);
        this.modAsync = modAsync;
    }
    async addDataStore(name, dataStore) {
        return await this.mutex.runExclusive(async () => {
            const result = parseWasmResult(await this.modAsync.AddDataStore(name, dataStore));
            return this.mapDataStoreInfo(result);
        });
    }
    async removeDataStore(name) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.RemoveDataStore(name));
        });
    }
    async getInternalDataStore(name) {
        const result = await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.GetInternalDataStore(name));
        });
        if (result.kind === 'None') {
            return undefined;
        }
        return this.mapDataStoreInfoInternal(result);
    }
    async listDataStores() {
        const result = await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.ListDataStores());
        });
        return result.map(this.mapDataStoreInfo);
    }
    async listDataStoreStats() {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.ListDataStoreStats());
        });
    }
    async initializeRekey(name, accessKey, hubEncryptedSecretKey, adminEncryptedSecretKey) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.InitializeRekey(name, accessKey, hubEncryptedSecretKey, adminEncryptedSecretKey));
        });
    }
    async listExternalFilesByDataStoreName(dataStoreName, limit, cursor) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.ListExternalFilesByDataStoreName(dataStoreName, limit, cursor));
        });
    }
    mapDataStoreInfo = (result) => {
        const common = {
            name: result.name,
            keyId: result.keyId,
        };
        if (result.kind === DataStoreKind.HTTP_LINK) {
            return { ...common, kind: DataStoreKind.HTTP_LINK };
        }
        return {
            ...common,
            kind: DataStoreKind.S3,
            bucketName: result.bucketName,
            region: result.region,
            endpointOverride: result.endpointOverride,
            httpScheme: result.httpScheme ? HTTPScheme.HTTPS : HTTPScheme.HTTP,
            useVirtualAddressing: result.useVirtualAddressing,
            accessKey: result.accessKey,
            urlExpirationMinutes: result.urlExpirationMinutes,
            rekeyState: parseRekeyState(result.rekeyState),
        };
    };
    mapDataStoreInfoInternal = (result) => {
        const info = this.mapDataStoreInfo(result);
        if (info.kind === DataStoreKind.HTTP_LINK) {
            return info;
        }
        return {
            ...info,
            hubEncryptedSecretKey: result.hubEncryptedSecretKey,
            adminEncryptedSecretKey: result.adminEncryptedSecretKey,
        };
    };
}
